import { useEffect, useState } from 'react';
import { fetchCourses, fetchSessions } from 'Api/dashboardPage';

const useFetch = ({ userId }) => {
  const [courses, setCourses] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [events, setEvents] = useState([]);
  const [recentlyUpdateCourses, setRecentlyUpdateCourses] = useState(null);
  const [remoteTraining, setRemoteTraining] = useState([]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchCourses({ userId }).then(data => {
        setCourses(data.courses);
        setRecentlyUpdateCourses(data.courses.slice(0, 4));
        setDocuments(data.documents.slice(0, 2));
      });
    }

    return () => {
      isMounted = false;
      setCourses([]);
      setRecentlyUpdateCourses(null);
      setDocuments([]);
    };
  }, [userId]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchSessions({ courses, userId }).then(data => {
        setEvents(data.sessions);
        setRemoteTraining(data.remoteSessions.slice(0, 2));
      });
    }

    return () => {
      isMounted = false;
      setEvents([]);
      setRemoteTraining([]);
    };
  }, [userId, courses]);

  return { documents, events, recentlyUpdateCourses, remoteTraining };
};

export default useFetch;
